import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, GeoJSON, Marker, Popup } from 'react-leaflet';
import L from 'leaflet'; // để tạo icon
import axios from 'axios';
import 'leaflet/dist/leaflet.css';
import { PacmanLoader } from 'react-spinners';
import coordinates from './coordinates.json'

const VietnamMap = ({ vietnamOrderData }) => {
  vietnamOrderData = vietnamOrderData.map(order => {
    const coordinate = coordinates.data.find(c => c.name === order.name) //coordinate là object
    if (coordinate) {
      return {
        ...order,
        coordinates: [parseFloat(coordinate.latitude), parseFloat(coordinate.longitude)]
      }
    }
    return order // không tìm thấy thì thoi
  })
  const [geoJsonData, setGeoJsonData] = useState(null);

  useEffect(() => {
    // Tải GeoJSON từ URL (dữ liệu bản đồ Việt Nam)
    axios
      .get(
        "https://res.cloudinary.com/pv-duc/raw/upload/v1626132866/province.json"
      )
      .then((response) => {
        setGeoJsonData(response.data);
      })
      .catch((error) => {
        console.error("Error loading GeoJSON:", error);
      });
  }, []);

  // Tìm top 3 (đỏ), 3 tiếp theo (vàng), và các vị trí còn lại (xám)
  const categorizedData = vietnamOrderData.sort((a, b) => b.orders - a.orders);
  const top3 = categorizedData.slice(0, 3); // Top 3 đơn hàng cao nhất
  const next3 = categorizedData.slice(3, 6); // 3 đơn hàng tiếp theo
  const others = categorizedData.slice(6); // Còn lại

  // Tạo các icon với màu sắc tương ứng
  const createIcon = (color) =>
    L.divIcon({
      className: "custom-icon",
      html: `<div style="background-color: ${color}; width: 20px; height: 20px; border-radius: 50%; border: 2px solid white;"></div>`,
    });

  if (!geoJsonData) return <PacmanLoader color="#5E2E86" />;

  return (
    <MapContainer
      center={[14.0583, 108.2772]}
      zoom={5}
      style={{ height: "100%", width: "100%" }}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {/* Vẽ bản đồ các tỉnh thành */}
      <GeoJSON data={geoJsonData} />

      {/* Hiển thị các Marker */}
      {top3.map((place, index) => (
        <Marker
          key={`top3-${index}`}
          position={place.coordinates}
          icon={createIcon("red")}
        >
          <Popup>
            <h3>{place.name}</h3>
            <p>Số lượng đơn hàng: {place.orders}</p>
          </Popup>
        </Marker>
      ))}
      {next3.map((place, index) => (
        <Marker
          key={`next3-${index}`}
          position={place.coordinates}
          icon={createIcon("yellow")}
        >
          <Popup>
            <h3>{place.name}</h3>
            <p>Số lượng đơn hàng: {place.orders}</p>
          </Popup>
        </Marker>
      ))}
      {others.map((place, index) => (
        <Marker
          key={`others-${index}`}
          position={place.coordinates}
          icon={createIcon("gray")}
        >
          <Popup>
            <h3>{place.name}</h3>
            <p>Số lượng đơn hàng: {place.orders}</p>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default VietnamMap;



